import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
// import { KillYourMasters } from "./components/KillYourMasters";
// import { Friday } from "./components/Friday";
import "./index.css";

const router = createBrowserRouter([
	{
		path: "/",
		element: <App />,
	}
	// {
	// 	path: "/rtj",
	// 	element: <KillYourMasters />,
	// }
	// {
	// 	path: "/friday",
	// 	element: <Friday />,
	// },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
	<React.StrictMode>
		<RouterProvider router={router} />
	</React.StrictMode>
);
